import React, { useState, useEffect } from "react";
import ConsentInline from "../../Quiz/ConsentInline/ConsentInline";
import "./Login.css";
import { useNavigate } from "react-router-dom";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [consentGiven, setConsentGiven] = useState(false);

  // Check cookie on mount
  useEffect(() => {
    const consent = getCookie("consentGiven");
    if (consent === "true") {
      setConsentGiven(true);
    }
  }, []);

  // When consent is given, store in cookie
  const handleConsent = () => {
    setConsentGiven(true);
    document.cookie = "consentGiven=true; path=/; max-age=86400"; // 1 day
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/login`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      }
    );
    const data = await response.json();
    if (response.ok) {
      navigate(`/Dashboard`);
    } else {
      alert(data.error);
    }
  };

  return (
    <div className="login-container">
      <header className="login-header">
        <button
          onClick={() => navigate(`/consent`, { state: { from: "login" } })}
        >
          Take Quiz as Guest
        </button>
      </header>
      <br></br>
      <div className="login-title">
        <h1>Welcome to the Empathy Tool!</h1>
      </div>
      <br></br>
      {consentGiven ? (
        <div className="login-body">
          <h1>Login</h1>
          <form onSubmit={handleLogin}>
            <input
              type="text"
              placeholder="Enter your username here"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              type="password"
              placeholder="Enter your password here"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit">Login</button>
            <button onClick={() => navigate(`/Register`)}>Register</button>
          </form>
          <p>
            <a href="/forgot-password">Forgot your password?</a>
          </p>
        </div>
      ) : (
        <ConsentInline onConsent={handleConsent} />
      )}
    </div>
  );
}

export default Login;
